// extracted by mini-css-extract-plugin
export default {"scroll":"style_scroll__VFNM3","item":"style_item__t1sjk","empty":"style_empty__QoqtU"};